console.log(`
         .8MM8..
      .MMMMMMMMMMM.
    .MMMMMMMMMMMMMMM                           MMN
   IMM8OMMMMMMMMM$DMM,                        =MMM
  :MMM~  .,MMM..  ZMMM.         :I.     ....: .        ++     ...  +,. .....  ....
  MMMMM.         .MMMMM     .MMMMMMMM. $MMNMM MMM.  MMMMMMM:  MMMMMMMM  7MMN.MMM+.
  MMMMMM         MMMMMM.   .MMM?..MMMO.MMMM8+ MMM IMMM..:MMM. MMM .MMM:  MMMMMM
  MMMMMM.       .MMMMMM.  .MMM.   .MMM MMM   .MMM MMM    MMM .MMD. MMM    MMMM.
  MMMMMM        .MMMMMM    MMM.   MMM,.MMM   DMM~ MMM.   MMM MMM, .MMM  .MMMMM
  MMMMM.          MMMMM.   :MMMMMMMM~ OMM=   MMM  MMMMMMMMM  MMM  ,MMM  MMM.MMM
  ,MMM:  ..MMM.   $MMM       MMMMM$   MMM.   MMM.  =MMMMM   .MMM  8MM:=MMM. ?MMM.
  .?MMO8MMMMMMMMM7NMM,
    .MMMMMMMMMMMMMMM
      .MMMMMMMMMMM
          .8M8..
`)
